import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=0eb5356b&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style1 from "./Aside.vue?vue&type=style&index=1&id=0eb5356b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb5356b",
  null
  
)

export default component.exports